import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import {
  enableCPTexting,
} from 'src/actions/accountActions';
import CardEnableCPTexting from 'src/containers/EnableCPTexting/CardEnableCPTexting';
import * as Yup from 'yup';

function EnableCPTextingForm({
  classes,
  loading = false,
  onConfirmationChange = () => { },
}) {
  const dispatch = useDispatch();

  const initialValues = {
    isConfirmed: false,
  };

  const validationSchema = Yup.object().shape({
    isConfirmed: Yup.boolean()
      .oneOf([true], 'You must confirm that you are ready to activate CP texting')
      .required('Confirmation is required'),
  });

  const onSubmit = async (values, {
    resetForm,
    setErrors,
    setStatus,
    setSubmitting
  }) => {
    console.log('Form submitted with values:', values); // Add this debug log

    const doWhenTry = () => {
      resetForm();
      setStatus({ success: true });
      setSubmitting(false);
    };
    const doWhenCatch = (error) => {
      setStatus({ success: false });
      setErrors({ submit: error.message });
      setSubmitting(false);
    };

    // Check if confirmed (this should already be validated by Yup)
    if (!values.isConfirmed) {
      setErrors({ submit: 'Please confirm that you are ready to activate CP texting.' });
      setSubmitting(false);
      return;
    }

    dispatch(enableCPTexting(doWhenTry, doWhenCatch));
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const {
    handleSubmit,
    setFieldValue,
    values,
  } = formik;

  // Handle confirmation change from the card component
  const handleConfirmationChange = React.useCallback((confirmed) => {
    console.log('Confirmation changed:', confirmed); // Add this debug log
    setFieldValue('isConfirmed', confirmed);
    onConfirmationChange(confirmed);
  }, [setFieldValue, onConfirmationChange]);

  return (
    <form
      id="formEnableCPTexting"
      className={classes.form}
      onSubmit={handleSubmit}
    >
      <CardEnableCPTexting
        classes={classes}
        loading={loading}
        isConfirmed={values.isConfirmed}
        onConfirmationChange={handleConfirmationChange}
      />
    </form>
  );
}

EnableCPTextingForm.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  onConfirmationChange: PropTypes.func,
};

export default EnableCPTextingForm;
